<template>
  <v-card outlined class="card-height" @dragstart="dragstart">
    <v-card-title class="pb-0 pt-1">
      <a-plain-text-component :rules="[serverRule(`${prefix}.fonction`)]">
        <strong>{{ fonction }}</strong>
      </a-plain-text-component>
    </v-card-title>
    <v-card-text style="position: relative" class="p-0">
      <v-fade-transition mode="in-out">
        <a-supprime-stamp v-if="estSupprime" />
        <a-ajoute-stamp v-if="estAjout" />
        <a-modifie-stamp v-if="estModifie" />
      </v-fade-transition>
      <v-row class="h100 d-flex align-center" dense>
        <v-col cols="10">
          <template v-if="personnePhysique">
            <a-plain-text-div>
              <a-plain-text-component
                :rules="[serverRule(`${prefix}.civilite`)]"
                ref="civilite"
              >
                {{ civilite | civilite }}
              </a-plain-text-component>
              <a-plain-text-component :rules="[serverRule(`${prefix}.nom`)]" ref="nom">
                {{ nom }}
              </a-plain-text-component>
              <a-plain-text-component
                :rules="[serverRule(`${prefix}.prenom`)]"
                ref="prenom"
              >
                {{ prenom }}
              </a-plain-text-component>
            </a-plain-text-div>
            <a-plain-text-div v-if="comite">
              Nationalité :&nbsp;
              <a-plain-text-component
                :rules="[serverRule(`${prefix}.nationalite`)]"
                ref="nationalite"
              >
                {{ nationalite }}
              </a-plain-text-component>
            </a-plain-text-div>
          </template>
          <a-plain-text-div v-if="personneReprise">
            <a-plain-text-component
              :rules="[serverRule(`${prefix}.description`)]"
              ref="description"
            >
              {{ description }}
            </a-plain-text-component>
          </a-plain-text-div>
          <template v-if="personneMorale">
            <a-plain-text-div>
              <a-plain-text-component
                :rules="[serverRule(`${prefix}.civilite`)]"
                ref="civilite"
              >
                {{ civilite | civilite }}
              </a-plain-text-component>
              <a-plain-text-component
                :rules="[serverRule(`${prefix}.nomRepresentant`)]"
                ref="nomRepresentant"
              >
                {{ nomRepresentant }}
              </a-plain-text-component>
              <a-plain-text-component
                :rules="[serverRule(`${prefix}.prenomRepresentant`)]"
                ref="prenomRepresentant"
              >
                {{ prenomRepresentant }}
              </a-plain-text-component>
              représentant la/le&nbsp;
              <a-plain-text-component
                :rules="[serverRule(`${prefix}.formeJuridique`)]"
                ref="formeJuridique"
              >
                {{ formeJuridique }}
              </a-plain-text-component>
              <a-plain-text-component
                :rules="[serverRule(`${prefix}.denomination`)]"
                ref="denomination"
              >
                {{ denomination }}
              </a-plain-text-component>
            </a-plain-text-div>
            <template v-if="numeroInscription">
              <a-plain-text-div>
                N° d'inscription :&nbsp;
                <a-plain-text-component
                  :rules="[serverRule(`${prefix}.numeroInscription`)]"
                  ref="numeroInscription"
                >
                  {{ numeroInscription }}
                </a-plain-text-component>
              </a-plain-text-div>
            </template>
          </template>

          <a-plain-text-div>
            <a-plain-text-component
              :rules="[serverRule(`${prefix}.adresse.adresse`)]"
              ref="adresse"
            >
              {{ adresse.adresse }}
            </a-plain-text-component>
          </a-plain-text-div>
          <a-plain-text-div>
            <a-plain-text-component
              :rules="[serverRule(`${prefix}.adresse.complementAdresse`)]"
              ref="complementAdresse"
            >
              {{ adresse.complementAdresse }}
            </a-plain-text-component>
          </a-plain-text-div>
          <a-plain-text-div>
            <a-plain-text-component
              :rules="[serverRule(`${prefix}.adresse.codePostal`)]"
              ref="codePostal"
            >
              {{ adresse.codePostal }}
            </a-plain-text-component>
            <a-plain-text-component
              :rules="[serverRule(`${prefix}.adresse.commune`)]"
              ref="commune"
            >
              {{ adresse.commune }}
            </a-plain-text-component>
            <a-plain-text-component
              :rules="[serverRule(`${prefix}.adresse.pays`)]"
              ref="pays"
            >
              {{ adresse.pays }}
            </a-plain-text-component>
          </a-plain-text-div>
          <a-plain-text-div v-if="telephone">
            <a-plain-text-component
              :rules="[serverRule(`${prefix}.telephone`)]"
              ref="telephone"
            >
              Téléphone :&nbsp;{{ telephone }}
            </a-plain-text-component>
          </a-plain-text-div>
          <a-plain-text-div v-if="email">
            <a-plain-text-component :rules="[serverRule(`${prefix}.email`)]" ref="email">
              Adresse courriel :&nbsp;{{ email }}
            </a-plain-text-component>
          </a-plain-text-div>
        </v-col>
        <v-col cols="2">
          <template v-if="hasModifie">
            <a-tooltip-icon-button
              icon="mdi-pen"
              :tooltip="`Modifier les informations du ${typeMembre}`"
              @click="modifie"
              data-testid="modifier-informations-membre"
            />
          </template>
          <template v-if="hasSupprime">
            <a-tooltip-icon-button
              icon="mdi-delete"
              :tooltip="`Supprimer le ${typeMembre}`"
              @click="supprime"
              data-testid="supprimer-membre"
            />
          </template>
          <template v-if="hasUndo">
            <a-tooltip-icon-button
              icon="mdi-undo"
              :tooltip="`Annuler la suppression du ${typeMembre}`"
              @click="undo"
              data-testid="annuler-suppression-membre"
            />
          </template>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import makePersonneCard from "./makePersonneCard";
import { mapPhysique, mapMorale } from "./EditionPersonneDialog.vue";

function map(src, dest) {
  dest.action = src.action || null;
  dest.statut = src.statut || null;
  dest.prefix = src.prefix;
  dest.type = src.type;
  dest.description = src.description;
  mapPhysique(src, dest);
  mapMorale(src, dest);
}

export default {
  mixins: [makePersonneCard(map)],
  props: {
    mode: {
      type: String,
      required: false,
    },
  },
  methods: {
    dragstart(evt) {
      this.$emit("dragstart", evt);
    },
  },
  computed: {
    estAjout() {
      return "ajout" === this.statut && !this.estSupprime;
    },
    estModifie() {
      return "modifie" === this.statut && !this.estSupprime;
    },
    liquidation() {
      return "liquidateur" === this.mode;
    },
    comite() {
      return !this.liquidation;
    },
    typeMembre() {
      if (this.liquidation) {
        return "liquidateur";
      }
      return "membre";
    },
  },
};
</script>

<style scoped>
.card-height {
  min-height: 68px;
}
</style>
